import React from 'react';
import css from './PrivacyNotification.css';
import { IconShieldM } from '../../../icons';
import classNames from 'classnames';

export default ({ mapPanelOpen }) => (
    <p
        className={classNames(css.root, {
            [css.fullScreenView]: Boolean(mapPanelOpen),
        })}
    >
        <IconShieldM />{' '}
        <span>
            Profile auf der Karte werden zum Schutz der Privatsphäre nur ungefähr angezeigt.
        </span>
    </p>
);
